module.exports = __webpack_public_path__ + "img/grudefault.88040a07.png";